import { de, enUS, es, fr, it, pt } from "date-fns/locale";
import { getDateDisplayLanguage } from "./dateDisplay";

const DATE_LOCALES = { de, en: enUS, es, fr, it, pt };

export const getDateFnsLocale = (language) =>
  DATE_LOCALES[getDateDisplayLanguage(language)] || fr;
